'use strict';
import { module } from '../app';

module.directive('iframeWrapper', ['modalService', '$q', '$http', '$compile', '$sce', function (modalService, $q, $http, $compile, $sce) {
    return {
        scope: {
            uri: '=',
            fileType: '=',
            onError: '&onError',
            onLoad: '&onLoad'
        },
        link: function (scope, element, attrs) {
            let loadedUri = '';

            async function fetchContent(url, type) {
              try {
                const response = await fetch(url, {
                  method: "GET",
                  mode: "cors",
                });

                if (response.status !== 200) {
                  throw new Error(`Failed to fetch ${type} file`);
                }

                if (type === 'txt') {
                  return await response.text();
                } else {
                  return await response.blob();
                }
              } catch (err) {
                throw err;
              }
            }

            scope.$watch("uri", async function (uri) {
              if (loadedUri !== uri) {
                try {
                  let content;
                  const type = scope.fileType;

                  const fileContent = await fetchContent(uri, type);

                  loadedUri = uri;
                  let iFrameHtml;
                  if (type === 'pdf') {
                    content = URL.createObjectURL(fileContent);
                    iFrameHtml = '<iframe class="pdf-iframe" scrolling="no" src="" iframe-onload="onLoad()" skip-hiding="true" />';
                    const markup = $compile(iFrameHtml)(scope);
                    element.empty();
                    element.append(markup);
                    const iframe = document.querySelector("iframe");
                    iframe.src = content;
                  } else if (type === 'txt') {
                    content =
                      '<div class="txt-content-wrapper"><div class="txt-content"><pre>' +
                      fileContent +
                      "</pre></div></div>";
                    element.empty();
                    element.append(content);
                    scope.onLoad();
                  }

                } catch (error) {
                  console.error("Error loading document:", error);
                  modalService.showErrorMessage(`Error on loading document.`);
                  scope.onError();
                }
              }
            });
        }
    };
}]);


// WEBPACK FOOTER //
// ./src/scripts/directives/iframeWrapper.js